module.exports = __webpack_public_path__ + "static/img/pic_ai_video_1.6d906be.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic_ai_video_1.gif
// module id = EfU0
// module chunks = 1